import LoadingGeneral from './loading-general.vue'
export default LoadingGeneral
